import { FC, useEffect, useState } from 'react';
// @ts-ignore
import SimplePrivacyPolicy from '@lds/simple-privacy-policy';
import { useDetermineLocale } from '@/hooks/use-determine-locale';

//lds style sheet
import '@lds/privacy-policy/dist/index.scss';

const FooterPrivacyPolicy: FC = () => {
  const locale = useDetermineLocale();

  const [isDocumentPresent, setIsDocumentPresent] = useState(false);
  useEffect(() => {
    return setIsDocumentPresent(true);
  }, []);

  return isDocumentPresent ? <SimplePrivacyPolicy lang={locale} /> : null;
};

export default FooterPrivacyPolicy;
